import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 右矢印アイコン
 */
const RightArrowIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="11.396"
        viewBox="0 0 7 11.396"
      >
        <path
          d="M4.769,10.042.146,5.473a.487.487,0,0,1,0-.7L4.769.209a.728.728,0,0,1,1.02,0,.708.708,0,0,1,0,1.008L1.835,5.125,5.789,9.033a.708.708,0,0,1,0,1.009.728.728,0,0,1-1.02,0"
          transform="translate(6.5 10.823) rotate(180)"
          fill={props.color}
          stroke={props.color}
          strokeWidth="1"
        />
      </svg>
    </Icon>
  )
}

export default RightArrowIcon
